import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import { matchPath } from 'react-router';

/**
 * @param {*} data  data: text or {content: text}
 * @param {*} isWaitingChat  data rendered WaitingGPTResponse is text format and MessagesList is object like {content: text}
 * @returns
 */
export default function AIResponse({ data, isWaitingChat, isPublicSite }) {
    return (
        <>
            <ReactMarkdown
                className="ai-response"
                remarkPlugins={[remarkGfm]}
                components={{
                    a: ({ href, children }) => (
                        <CustomerUrl href={href} isPublicSite={isPublicSite}>
                            {children}
                        </CustomerUrl>
                    )
                }}
            >
                {isWaitingChat ? data : data?.content}
            </ReactMarkdown>
        </>
    );
}

const CustomerUrl = ({ href, children, isPublicSite }) => {
    const urlType = Utils.detectUrlType(href);
    let customHref = href;
    let isUrlInDesk = false;
    switch (urlType) {
        case Constant.PROTOCOL.HTTP:
        case Constant.PROTOCOL.HTTPS:
            let fullUrl = {};
            try {
                fullUrl = new URL(href);
                let urlPathName = fullUrl.pathname;
                let matchUrl = matchPath(urlPathName, {
                    path: Constant.SHARE_TICKET_ROUTER,
                    exact: true,
                    strict: true
                });
                const matchUrlShortLink = matchPath(urlPathName, {
                    path: Constant.SHORT_LINK_TICKET_ROUTER,
                    exact: true,
                    strict: true
                });

                // So sánh domain và router
                if (
                    ((!Utils.isEmptyObject(matchUrl) && matchUrl.isExact) ||
                        !!matchUrlShortLink?.isExact) &&
                    !isPublicSite
                ) {
                    const params = matchUrl ? matchUrl.params : null;
                    customHref = href;
                    if (params?.id) {
                        const id = params.id;
                        const newId = Utils.removeExtraCharactersOfIdTicket(id);
                        customHref = href.replace(id, newId);
                    }
                    isUrlInDesk = true;
                }
            } catch (error) {
                console.log('CustomerUrl err href: ', href);
                customHref = '#';
            }
            break;
        case Constant.PROTOCOL.FTP:
        case Constant.PROTOCOL.FILE:
        case Constant.PROTOCOL.NOTES:
        default:
            customHref = href;
    }

    if (isUrlInDesk) {
        return (
            <span className="markdown-redirect" onClick={() => window.onClickUrlViewTicket(customHref)}>
                {children}
            </span>
        );
    }

    return (
        <a
            className="markdown-redirect"
            href={customHref}
            target={customHref === '#' ? '' : '_blank'}
            rel="noopener noreferrer"
        >
            {children}
        </a>
    );
};
